import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './General/stylesheets/main.sass'
import PageController from './PageController.js'
import * as serviceWorker from './General/serviceWorker';
import { CookiesProvider } from 'react-cookie'

ReactDOM.render(<CookiesProvider><PageController /></CookiesProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
